import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import classNames from 'classnames';
import { confirmAlert } from 'react-confirm-alert'; // Import
import moment from 'moment';
import {PatientTodaysRecordABCDataListAction,deletePatientTodaysRecordABCDataAction,UpdateCollectedBehaviorData} from '../../actions/BehaviourDataActions';
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { showFormatedDateandTime,} from '../../../../../../../../actions/utilAction';
import { isFloat, renderTextField} from '../../../../../../../../components/reduxFields';
import {change, Field, reduxForm } from 'redux-form';
import { debounce} from 'lodash';




class RecordABCDataViewModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDecimalError:false,
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            deleteModal: false,
            creadtedDate: props.creadtedDate
        }
    }

    componentWillMount = () => {
        this.props.PatientTodaysRecordABCDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate)
    }
   
    componentWillReceiveProps(nextProps) {
        (nextProps.patientTodaysRecordABCDataList && nextProps.patientTodaysRecordABCDataList.data.PatRecordABCData || []).forEach((obj, index) => {
            this.props.dispatch(change('RecordABCDataViewModalForm', `Behavior[${index}].duration`, obj.timeInterval || 0));
        });
        if(nextProps.updatedCollectedBehaviorDataStatus && nextProps.updatedCollectedBehaviorDataStatus !== this.props.updatedCollectedBehaviorDataStatus){
            this.props.PatientTodaysRecordABCDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate)
        }
        

    }


    handleDecimalPoint = (e) => {
        const { value } = e.target;
      
        // Check if the value is empty or matches the decimal format
        if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
          // Count the number of decimal points
          const decimalPoints = (value.match(/\./g) || []).length;
      
          // Allow only up to one decimal point
          if (decimalPoints <= 1) {
            this.setState({ value });
      
            // Hide the error if there is one decimal point or none
            if (this.state.showDecimalError) {
              this.setState({ showDecimalError: false });
            }
            return;
          }
        }
      
        // Show error if there are multiple decimal points
        if (!this.state.showDecimalError) {
          this.setState({ showDecimalError: true });
        }
      };


    handleDurationChange = (event, data, action) => {
        this.setState({ showDecimalError: false });
        this.props.UpdateCollectedBehaviorData(data.id, data.recordABCDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, 0, event.target.value||0, this.state.patientId, 'DURATION', 'ABCDATA', this.props.uuid, this.state.creadtedDate)
    }

    // deBouncedHandleDurationChange = debounce(this.handleDurationChange,1000);

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    handleDeleteClick = (e, Obj) => {
        this.setState({
            deleteModal : true
        })
        
        confirmAlert({
            title: 'Delete Selected ABC Data',
            message: 'Are you sure you want to delete this ABC Data?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    this.props.deletePatientTodaysRecordABCDataAction(Obj.recordABCDataDetailId, this.state.patientId, this.props.uuid, this.state.creadtedDate)
                    this.setState({
                        deleteModal: false
                    })
                }

              },
              {
                label: 'No',
                onClick: () => {
                    this.setState({
                        deleteModal: false
                    })
                }
              }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
          });
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderData = (PatientTodaysRecordABCDataList) => {
        PatientTodaysRecordABCDataList = PatientTodaysRecordABCDataList || [];
        if (!PatientTodaysRecordABCDataList.length) {
            return (
                <tr>
                    <td colSpan="4">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientTodaysRecordABCDataList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>{Obj.behaviorCategoryName}</td>
                    <td>{showFormatedDateandTime(Obj.sessionTime)}</td>
                    <td>
                    <Field
                        name={`Behavior[${index}].duration`}
                        type="text"
                        maxLength="4"
                        label="Time"
                        onChange={this.handleDecimalPoint}
                        component={renderTextField}
                        normalize={isFloat}
                        disabled={ this.props.updatePermissionBehavior ? false: true}
                        onBlur={(event) => this. handleDurationChange(event, Obj, 'DURATION',`Behavior[${index}].duration`)}
                    />
                    {this.state.showDecimalError?<span style={{color:"rgb(244, 67, 54)",fontSize:"12px"}}>Invalid decimal number</span>:null}
                    </td>  
                    <td>
                    {this.props.deletePermissionBehavior && <button onClick={(e) => this.handleDeleteClick(e, Obj)} title="Delete" type="button" className="tbactionbtn redfont">
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>}
                    </td>
                </tr>
            )
        })
    }

    renderPatientRecordABCDataList = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientTodaysRecordABCDataList } = this.props;
        let PatientTodaysRecordABCDataList = (patientTodaysRecordABCDataList && patientTodaysRecordABCDataList.data.PatRecordABCData) || [];
        return (
            <div className="readmin-panel mt-10">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="40%">Category Name</th>
                                            <th width="25%">Session Time</th>
                                            <th width="25%">Time Interval</th>
                                            <th width="10%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientTodaysRecordABCDataList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const actions = [<CancelButton className="mr-15" onTouchTap={this.handleClose} />];
        return (
            <div>
                {!this.state.deleteModal && <Dialog
                    className="custom_modal"
                    title="Undo Past Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    {this.renderPatientRecordABCDataList()}
                </Dialog>}
            </div>
        )
    }
}

RecordABCDataViewModal = reduxForm({
    form: 'RecordABCDataViewModalForm',
    //enableReinitialize: true,
})(RecordABCDataViewModal);

function mapStateToProps(state) {
      
    return {        
        loading: state.patientBehaviourData.loading,
        patientTodaysRecordABCDataList: state.patientBehaviourData.patientTodaysRecordABCDataList, 
        updatedCollectedBehaviorDataStatus :state.patientBehaviourData.updatedCollectedBehaviorDataStatus,
    }
}

export default connect(mapStateToProps, { PatientTodaysRecordABCDataListAction, deletePatientTodaysRecordABCDataAction,UpdateCollectedBehaviorData})(RecordABCDataViewModal)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordABCData/RecordABCDataViewModal.js